/**
 * Viewport breakpoints for the Flow Studio shell. The numbers live in @flow-studio/store (the single
 * source, which uiStore also reads). They are re-exported here so layout code imports from one place.
 */
import { DESKTOP_MIN_WIDTH } from '@flow-studio/store';

export { MOBILE_MAX_WIDTH, DESKTOP_MIN_WIDTH } from '@flow-studio/store';

/**
 * Only desktop widths save the sidebar's collapsed state. Phones and tablets always start collapsed,
 * so saving from there would overwrite the user's desktop preference.
 */
export function shouldPersistNavCollapsed(width: number): boolean {
  return width >= DESKTOP_MIN_WIDTH;
}
